import { useDispatch, useSelector } from "react-redux";
import { setLoadingReply, concatMessage, incrementPosition, updateExpiredAt, setMessages, setIsqrLoading } from '../../features/messagesSlice';
import { setQrcodeUrl } from "../../features/sessionSlice";
import { GREETING_MSG_PRE, FIVE_MIN } from '../../../constants';
import { formatMessageDataV2 } from "../../utils/formatData";
import { handleFirstQRcode, handleSecondQRcode, handleCheckStatusQrcode } from "../../services/chatService";


const ServicesSelection = () => {

	const dispatch = useDispatch();
	const deviceId = useSelector((state) => state.session.deviceId); 
	const position = useSelector(state => state.messages.position);
	const messages = useSelector(state => state.messages.messages);

	const handleFAQService = () => {
		const serviceSelectionRemoved = messages.slice(1)
		dispatch(setMessages(serviceSelectionRemoved))
		const greetingMessage = formatMessageDataV2(deviceId, "bot", GREETING_MSG_PRE, position, true);
		dispatch(concatMessage(greetingMessage));
		dispatch(incrementPosition());
		dispatch(updateExpiredAt());
		dispatch(setLoadingReply(false))
	}

	// const handleSelfServiceTemp = async () => {

	// 	const serviceSelectionRemoved = messages.slice(1)
	// 	dispatch(setMessages(serviceSelectionRemoved))
	// 	const qrcodeMessage = formatMessageDataV2(deviceId, "bot", "", position, true);
	// 	dispatch(concatMessage(qrcodeMessage));
	// 	dispatch(incrementPosition());
	// 	dispatch(updateExpiredAt());

	// 	let mockCount = 0 // Illustrate user times to scan first qrcode. For real use case, i need to wait api return new key

	// 	// ---- QR1: 5-minute timeout + request abort ----
	// 	const controller = new AbortController();
	// 	const timeoutId = setTimeout(() => {
	// 		controller.abort(new DOMException("QR1 timed out after 5 minutes", "AbortError"));
	// 	}, FIVE_MIN);

	// 	try {
	// 		while (true) {
	// 			try {
	// 				const res = await generateFirstQRcode({ signal: controller.signal })
	// 				dispatch(setQrcodeUrl(res.url))
	// 			} catch (error) {

	// 				if (error?.name === "AbortError") {
	// 					// timed out – clean up and surface a friendly error
	// 					dispatch(setQrcodeUrl(null));
	// 					throw new Error("QR1 session expired. Please start again.");
	// 				}
	// 				// other network errors can be rethrown or handled here
	// 				throw error;
	// 			}
			
	// 			mockCount++
	// 			console.log(mockCount)
	// 			if (mockCount > 5) break;
	// 			await wait(1500)
	// 		}
			
	// 	} finally {
	// 		clearTimeout(timeoutId);
	// 	}

	// 	const r2 = await generateSecondQRcode();
  // 	if (!r2?.success) throw new Error("qr2 failed");
	// 	dispatch(setQrcodeUrl(r2.url))

	// 	let statusCount = 0 // Illustrate user times to scan 2nd qrcode. For real use case, i need to wait api return new key

	// 	while (true) {
	// 		const res = await generateSecondQRcode()
	// 		console.log(res)
	// 		statusCount++
	// 		if (statusCount > 5) break;
	// 		await wait(1500)
	// 	}

	// 	dispatch(setQrcodeUrl(null))

	// 	// Example after flow (no need to worry)
	// 	const serviceSelectionRemoved2 = messages.slice(1)
	// 	dispatch(setMessages(serviceSelectionRemoved2))
	// 	const greetingMessage = formatMessageDataV2(deviceId, "bot", GREETING_MSG_PRE, position, true);
	// 	dispatch(concatMessage(greetingMessage));
	// 	dispatch(incrementPosition());
	// 	dispatch(updateExpiredAt());
	// 	dispatch(setLoadingReply(false));
	// }

	const handleSelfService = async () => {
		dispatch(setIsqrLoading(true))
		const serviceSelectionRemoved = messages.slice(1)
		dispatch(setMessages(serviceSelectionRemoved))
		const qrcodeMessage = formatMessageDataV2(deviceId, "bot", "", position, true);
		dispatch(concatMessage(qrcodeMessage));
		dispatch(incrementPosition());
		dispatch(updateExpiredAt());
		try {
			await handleFirstQRcode(dispatch);
			const [qrcode2, statusRes] = await Promise.all([
				handleSecondQRcode(dispatch),
				handleCheckStatusQrcode(dispatch),
			]);
			dispatch(setQrcodeUrl(null))
			const serviceSelectionRemoved2 = messages.slice(1)
			dispatch(setMessages(serviceSelectionRemoved2))
			const greetingMessage = formatMessageDataV2(deviceId, "bot", GREETING_MSG_PRE, position, true);
			dispatch(concatMessage(greetingMessage));
			dispatch(incrementPosition());
			dispatch(updateExpiredAt());
			dispatch(setLoadingReply(false));
			
		} catch (error) {
				console.error("Self-service flow error:", error.message);
				// optional: show user-friendly error message here
				// // 🚨 stop flow — don’t continue
		}
	}

  return (
    <div className='service-selection-container'>
			<button className='self-service' onClick={()=>handleSelfService()}>Self Service</button>
			<button className='faq-service' onClick={()=> handleFAQService()}>FAQ</button>
    </div>
  )
}

export default ServicesSelection